module.exports = __webpack_public_path__ + "images/assets/216710b7a9852dc0e2f6d9016cf893ab.svg";